import { Zap, Flame, Droplets, PhoneCall } from "lucide-react";
import { UTILITIES, PHONE_DISPLAY, PHONE_TEL } from "@/lib/site-content";

const ICONS = { Zap, Flame, Droplets };

export default function Utilities() {
  return (
    <section
      id="utilities"
      data-testid="utilities-section"
      className="bg-zinc-50 py-20 sm:py-28 lg:py-32 border-b border-zinc-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="max-w-3xl mb-12">
          <p className="label-eyebrow mb-4">Utilities Covered</p>
          <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl text-zinc-900 leading-[1.02] tracking-tighter">
            Three essential services.
            <br />
            <span className="text-[#FF4500]">Zero runaround.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5 lg:gap-6">
          {UTILITIES.map((u) => {
            const Icon = ICONS[u.icon];
            return (
              <div
                key={u.id}
                data-testid={`utility-${u.id}`}
                className="group bg-white border border-zinc-200 hover:border-zinc-900 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl flex flex-col overflow-hidden"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={u.image}
                    alt={u.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div
                    className="absolute top-4 left-4 w-12 h-12 flex items-center justify-center"
                    style={{ backgroundColor: u.color, color: "#fff" }}
                  >
                    <Icon className="w-6 h-6" strokeWidth={2.5} />
                  </div>
                </div>
                <div className="p-6 sm:p-8 flex-1 flex flex-col">
                  <h3 className="font-display font-black text-2xl sm:text-3xl tracking-tight text-zinc-900">
                    {u.title}
                  </h3>
                  <p className="mt-3 text-zinc-600 text-sm sm:text-base leading-relaxed flex-1">
                    {u.blurb}
                  </p>
                  <a
                    href={PHONE_TEL}
                    data-testid={`utility-call-${u.id}`}
                    className="mt-6 inline-flex items-center justify-center gap-2 bg-[#FF4500] hover:bg-[#E63E00] text-white font-display font-bold py-3.5 transition-all active:scale-[0.97]"
                  >
                    <PhoneCall className="w-4 h-4" strokeWidth={2.7} />
                    Call {PHONE_DISPLAY}
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
